module.exports = __webpack_public_path__ + "img/modal-aceptar-rechazar.fda01563.svg";